(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-gift-card-recipient]').forEach(function (root) {
    var toggle = root.querySelector('[data-gift-card-toggle]');
    var fields = root.querySelector('[data-gift-card-fields]');
    var email = root.querySelector('[data-gift-card-email]');
    var date = root.querySelector('[data-gift-card-date]');
    var offset = root.querySelector('[data-gift-card-offset]');
    if (!toggle || !fields) return;

    // Timezone offset so "Send on" is interpreted in the buyer's local day.
    if (offset) offset.value = new Date().getTimezoneOffset().toString();
    if (date) {
      var today = new Date();
      var max = new Date(today); max.setDate(today.getDate() + 90);
      var iso = function (d) { return d.toISOString().slice(0, 10); };
      date.min = iso(today);
      date.max = iso(max);
    }

    var sync = function () {
      var on = toggle.checked;
      fields.hidden = !on;
      fields.disabled = !on; // disabled fieldset => its inputs are not submitted
      if (email) email.required = on;
    };
    toggle.addEventListener('change', sync);
    sync();
  });
  } catch(e) { console.error(e); }
})();

})();
